import {
  CLEAR_WS,
  INITIALIZE_WEB_SOCKETS_CHANNEL,
  WEBSOCKET_MESSAGE_RECEIVED
} from "../../constants/ActionTypes";

export const receiveMessage = (text) => ({ type: WEBSOCKET_MESSAGE_RECEIVED, text });
export const initializeWebSocketsChannel = (jwt) => ({ type: INITIALIZE_WEB_SOCKETS_CHANNEL, jwt});
export const clearWs = () => ({ type: CLEAR_WS });
